// removed by extract-text-webpack-plugin
module.exports = {"contactWrap":"qempo_Contact_contactWrap-3S8XWC9","hiddenSmall":"qempo_Contact_hiddenSmall-2U7SMHO","actionsWrap":"qempo_Contact_actionsWrap-1Pmah2h","addressWrap":"qempo_Contact_addressWrap-3SApSCb","box":"qempo_Contact_box-3NEBcbK"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/contact/components/Contact.scss
// module id = 1966
// module chunks = 0